import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ReportNotificationGroupsLastOpenedMutationVariables = Types.Exact<{
  input: Types.ReportNotificationGroupsLastOpenedInput;
}>;


export type ReportNotificationGroupsLastOpenedMutation = { __typename?: 'Mutation', reportNotificationGroupsLastOpened?: { __typename?: 'ReportNotificationGroupsLastOpenedPayload', successful: boolean } | null };


export const ReportNotificationGroupsLastOpened = /*#__PURE__*/ gql`
    mutation ReportNotificationGroupsLastOpened($input: ReportNotificationGroupsLastOpenedInput!) {
  reportNotificationGroupsLastOpened(input: $input) {
    successful
  }
}
    ` as unknown as DocumentNode<ReportNotificationGroupsLastOpenedMutation, ReportNotificationGroupsLastOpenedMutationVariables>;

          

          export const useReportNotificationGroupsLastOpenedMutation = (options?:MutationHookOptions<ReportNotificationGroupsLastOpenedMutation, ReportNotificationGroupsLastOpenedMutationVariables>) => useMutation(ReportNotificationGroupsLastOpened, options);
          

          export type ReportNotificationGroupsLastOpenedMutationOptions = MutationHookOptions<ReportNotificationGroupsLastOpenedMutation, ReportNotificationGroupsLastOpenedMutationVariables>;

          

          export type ReportNotificationGroupsLastOpenedMutationResult = ReturnType<typeof useReportNotificationGroupsLastOpenedMutation>[1];

          
